// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3gdNm","productName":"Table_productName__1qB4q"};